module.exports = __webpack_public_path__ + "img/oval.95bee847.svg";